import { createSelector } from 'reselect';
import { WEBLOGIN_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectWebloginDomain = state => state[WEBLOGIN_DOMAIN] || initialState;

export function selectWebloginVehicles(id) {
  return createSelector(selectWebloginDomain, weblogin => weblogin.vehicles);
}

export function selectWebloginVehicle(id) {
  return createSelector(selectWebloginDomain, weblogin => weblogin.vehiclesById[id]);
}

export const selectWebloginVehicleInvoices = () => createSelector(selectWebloginDomain, d => d.vehicleInvoices);




